import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ResultData } from '@app/core/_common/model';
import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  url :string = environment.url;

  private readonly _settings = new BehaviorSubject<ResultData>(<ResultData>{});
  public settings$ = this._settings.asObservable();
  private readonly _currentSettingKey = new BehaviorSubject<string>(<string>null);
  currentSettingKey$ = this._currentSettingKey.asObservable();

  private readonly _currentSetting = new BehaviorSubject<ResultData>(
    <ResultData>{},
  );
  currentSetting$ = this._currentSetting.asObservable();

  settingsKeyValue :any = [];

  constructor(private http :HttpClient) {
    this.getSettings();
  }

  getLogistics() {
    const settings :any = this._settings.getValue();

    return settings.LOGISTICS;
  }

  getSettings() {
    this.http.get(`${this.url}/settings`).subscribe((resp :any) => {
      this._settings.next(resp);
      if (this._currentSettingKey.value) {
        this._currentSetting.next(
          resp.find((setting) => setting.key === this._currentSettingKey.value),
        );
      }
    });
  }

  setSettingKey(key :string) :void {
    this._currentSettingKey.next(key);
  }
}
